import { render } from "./BadgeCustomizer.vue?vue&type=template&id=dd4e3ae8"
import script from "./BadgeCustomizer.vue?vue&type=script&lang=js"
export * from "./BadgeCustomizer.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/mydid-badgechecker-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__